import React from 'react';
import './Header.css';

const header = () => {
    return (
        <nav>
            <div className='header'>
                <h2>Where in the world?</h2>                
            </div>

        </nav>
    )
}

export default header;
